module.exports = __webpack_public_path__ + "static/industries-7ce9166249b587bc6d0223201a41c3c2.jpg";